import { breadcrumbJsonLd, faqJsonLd } from "@amtana/browser";
import type { SeoJsonLdBlock } from "@amtana/browser";
import type { PostFile } from "virtual:warike-posts";

import { postPath, tagPath } from "./behavior/warike-posts.ts";
import type { ListedPost } from "./behavior/warike-posts.ts";
import { WARIKE_SITE, WARIKE_WORDS } from "./model/warike-words.ts";

// The structured data warike.tech declares for a post and for a tag's page, block for block, so a
// page keeps what a search engine already reads on it (S41.12).

const HOME = { name: "Home", path: "/" };
const INSIGHTS = { name: WARIKE_WORDS.blog.name, path: "/blog" };
const CONTEXT = "https://schema.org";

export function postJsonLd(slug: string, file: PostFile): readonly SeoJsonLdBlock[] {
  const url = `${WARIKE_SITE.url}${postPath(slug)}`;
  return [
    {
      "@context": CONTEXT,
      "@type": "BlogPosting",
      headline: file.title,
      description: file.description,
      datePublished: file.publishedAt,
      author: { "@type": "Person", name: file.authorName },
      publisher: { "@type": "Organization", name: WARIKE_WORDS.brand },
      url,
      mainEntityOfPage: url,
      keywords: file.tags.join(", "),
    },
    ...(file.faq?.length ? [faqJsonLd(file.faq)] : []),
    breadcrumbJsonLd({
      siteUrl: WARIKE_SITE.url,
      items: [HOME, INSIGHTS, { name: file.title, path: postPath(slug) }],
    }),
  ];
}

export function tagJsonLd(tag: string, posts: readonly ListedPost[]): readonly SeoJsonLdBlock[] {
  return [
    {
      "@context": CONTEXT,
      "@type": "CollectionPage",
      name: `${tag} | ${WARIKE_WORDS.brand}`,
      url: `${WARIKE_SITE.url}${tagPath(tag)}`,
      mainEntity: {
        "@type": "ItemList",
        itemListElement: posts.map((post, index) => ({
          "@type": "ListItem",
          position: index + 1,
          url: `${WARIKE_SITE.url}${postPath(post.slug)}`,
          name: post.file.title,
        })),
      },
    },
    breadcrumbJsonLd({
      siteUrl: WARIKE_SITE.url,
      items: [HOME, INSIGHTS, { name: tag, path: tagPath(tag) }],
    }),
  ];
}
